export function isNew(iso, days = 7) {
  if (!iso) return false;
  return Date.now() - new Date(iso).getTime() < days * 86400 * 1000;
}
